export default function Interests() {
  return (
    <section id='interests' className='content'>
      <h3>Interests</h3>
      <p>
        Skier. Sailor. Cyclist. Coffee snob. Scotch lover. Craft beer afficianado. Peanut
        butter addict.
      </p>
    </section>
  );
}
